const DEFAULT_POLL_SECONDS = 60
const MIN_POLL_SECONDS = 1
const MAX_POLL_SECONDS = 600

export function getChatMailboxPollIntervalMs() {
    const fromWindow = Number(window?.Laravel?.chatMailboxPollSeconds)
    const fromMix = Number(process.env.MIX_CHAT_MAILBOX_POLL_SECONDS)
    const seconds = Number.isFinite(fromWindow) && fromWindow > 0
        ? fromWindow
        : (Number.isFinite(fromMix) && fromMix > 0 ? fromMix : DEFAULT_POLL_SECONDS)

    return Math.min(MAX_POLL_SECONDS, Math.max(MIN_POLL_SECONDS, Math.round(seconds))) * 1000
}
